import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialStrip } from './components/TestimonialStrip';
import { ProblemSection } from './components/ProblemSection';
import { MegapackOverview } from './components/MegapackOverview';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { PackEliteComparison } from './components/PackEliteComparison';
import { TestimonialsGrid } from './components/TestimonialsGrid';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-navy-900 text-gray-200 font-inter selection:bg-gold-500 selection:text-navy-950" data-id="element-0">
      <Hero data-id="element-1" />
      <TestimonialStrip data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <MegapackOverview data-id="element-4" />
      <TomosSection data-id="element-5" />
      <BonosSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <PackEliteComparison data-id="element-8" />
      <TestimonialsGrid data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <CostComparison data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}